import { CompetitionsMatchCardSchema } from './CompetitionsMatchCard.styles';

export const competitionsMatchCardStyles: CompetitionsMatchCardSchema = {
  vsBoxWrapper: {
    position: 'relative',
    p: '1',
  },
  vsDivider: {
    borderStyle: 'dashed',
    borderColor: '#222',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.2)',
    ml: '20px',
    opacity: '0.2',
    w: '97%',
  },
  absoluteCenter: {
    px: '2',
    left: '2',
    ml: '1px',
    fontWeight: 'bold',
    color: 'beta.300',
    fontFamily: 'accent',
    fontSize: 'xs',
    textTransform: 'uppercase',
  },
  matchCardOverride: {
    mb: '2',
  },
  propositionButtonOverride: {
    w: '100%',
  },
  gridItem: {
    w: '100%',
  },
  flexWrapper: {
    alignItems: 'center',
  },
  flexText: {
    as: 'span',
    flex: '1',
    textAlign: 'left',
    fontWeight: 'bold',
    fontFamily: 'accent',
    fontSize: 'xs',
    color: 'white',
  },
  gridWrapper: {
    gap: 2,
  },
  propositionButtonOverrideSecondary: {
    variant: 'odds',
    w: ['50px', '100px'],
    px: ['0', null, 'inherit'],
  },
  gridItemTextNoProposition: {
    w: ['50px', '100px'],
    h: 'full',
    minH: '10',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'body',
    fontWeight: 'black',
    fontSize: 'sm',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'base',
    border: '2px',
    borderColor: 'whiteAlpha.300',
    bg: 'transparent',
  },
  flexAwayTeam: {
    alignItems: 'center',
  },
  flexAwayTeamText: {
    flex: '1',
    textAlign: 'left',
    fontFamily: 'accent',
    fontWeight: 'bold',
    fontSize: 'xs',
    color: 'white',
  },
};
